// External Imports
import { pxToRem } from '@lessonnine/design-system.lib';

// Local Functions
function pxToRemParse(pixelString) {
  return pxToRem(parseInt(pixelString, 10));
}

// Module Exports
export { pxToRemParse };
